import { format } from 'date-fns';

/** @deprecated Use toDatetimeLocalValue from tournamentDateTime.ts with venue timezone. */
export const getStringDateFormat = (date: string | null): string => {
    return format(new Date(date || Date.now()), `yyyy-MM-dd'T'HH:mm`);
};

export const getDateAsUtc = (date: Date | string) => {
    return (new Date(date)).toISOString();
}

/** @deprecated Use formatInVenueTimeZone with venue timezone instead. */
export const getTime = (date: string | Date): string => {
    return format(new Date(date), `HH:mm`);
};

/** @deprecated Use formatVenueDateOnly with venue timezone instead. */
export const getDate = (date: string | Date): string => {
    return format(new Date(date), 'dd/MM yyyy');
};

/** @deprecated Use formatVenueDateWithTime with venue timezone instead. */
export const getDateWithTime = (date: string | Date): string => {
    return format(new Date(date), 'dd/MM/yyyy hh:mm');
}

/** @deprecated Use formatVenueReadableDate with venue timezone instead. */
export const getReadableDate = (date: string | Date): string => {
    return format(new Date(date), 'EEEE dd MMM yyyy hh:mm');
}

/** @deprecated Use formatVenuePublicDate with venue timezone instead. */
export const getReadableForPublioDate = (date: string | Date): string => {
    return format(new Date(date), `EEEE dd MMM yyyy 'at' hh:mm`);
}
